import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Relationships section on a contact profile: link/unlink decisions resolve
// via turbo streams (the section is replaced server-side); this controller
// only surfaces a toast for the decision that just happened.
export default class extends Controller {
    connect() {
        this.boundSubmitEnd = (event) => this.submitEnded(event)
        this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
    }

    disconnect() {
        this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
    }

    submitEnded(event) {
        if (!event.detail.success) return

        let toast = event.target.dataset.toast
        if (toast) showSystemToast(toast)
    }
}
